import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "@/redux/store";
import { useSelector } from "react-redux";

import { Modal, Button } from "@/components";
import { fetchLogout } from "@/redux/profile/authAndReg/asyncActions";
import { setAuth } from "@/redux/profile/authAndReg/slice";
import { cartSelector } from "@/redux/cart/selectors";
import { setCartItems, resetCartItems } from "@/redux/cart/slice";
import { IRacket, ISeat, ITotalCartItems } from "@/pages/Cart/types";
import {
  removeTokenToStorage,
  removePartnerIdFromStorage,
  removeCartItemsFromStorage,
  setCartItemsToStorage,
} from "@/utils";

import Styles from "./LogoutConfirmModal.module.scss";

interface LogoutConfirmModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
  isOpen,
  setIsOpen,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { totalCartItems } = useSelector(cartSelector);

  const deleteItemsCart = (totalCartItems: ITotalCartItems | any) => {
    const cloneCartItems = JSON.parse(JSON.stringify(totalCartItems));
    let filtredCartItems: {
      [key: string]: {};
    } = {
      rackets: { ...cloneCartItems.rackets },
      seats: { ...cloneCartItems.seats },
    };

    let deletedCartItems = {
      rackets: {},
      seats: {},
    };

    for (let type in totalCartItems) {
      for (let item in totalCartItems[type]) {
        const itemId = totalCartItems[type][item].id;
        const filtredItems = Object.keys(filtredCartItems[type])
          .filter((key) => totalCartItems[type][key].id !== itemId)
          .reduce((res: { [key: string]: ISeat | IRacket }, key) => {
            res[key] = totalCartItems[type][key];
            return res;
          }, {});

        if (type === "seats") {
          filtredCartItems.seats = { ...filtredItems };

          deletedCartItems.seats = {
            ...deletedCartItems.seats,
            ...{ [item]: totalCartItems[type][item] },
          };
        }

        if (type === "rackets") {
          filtredCartItems.rackets = { ...filtredItems };

          deletedCartItems.rackets = {
            ...deletedCartItems.rackets,
            ...{ [item]: totalCartItems[type][item] },
          };
        }
      }
    }

    const totalDeletedItems = {
      delArr: deletedCartItems,
    };

    if (
      Object.keys(deletedCartItems.rackets).length ||
      Object.keys(deletedCartItems.seats).length
    ) {
      setCartItemsToStorage(filtredCartItems);
      dispatch(setCartItems(filtredCartItems));
    }
  };

  const handleConfirm = async () => {
    try {
      deleteItemsCart(totalCartItems);
      
      await dispatch(fetchLogout());
      
      dispatch(resetCartItems());
      dispatch(setAuth(null));
      removeTokenToStorage();
      removePartnerIdFromStorage();
      removeCartItemsFromStorage();
      
      setIsOpen(false);
      navigate("/");
    } catch (error) {
      console.error("Ошибка при выходе:", error);
      dispatch(resetCartItems());
      dispatch(setAuth(null));
      removeTokenToStorage();
      removePartnerIdFromStorage();
      removeCartItemsFromStorage();
      setIsOpen(false);
      navigate("/");
    }
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      title="Выход"
      subTitle="Выйти из учетной записи?"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      closeFunc={handleCancel}
      mobileContentSize="fixed"
    >
      <div className={Styles.buttons}>
        <Button onClickFunc={handleCancel}>
          Нет
        </Button>
        <Button onClickFunc={handleConfirm} newStyles={Styles.logoutButton}>
          Да
        </Button>
      </div>
    </Modal>
  );
};
